var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Red Car - Top View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3876"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: 0,
    id: "stop3878"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    stopOpacity: 0,
    offset: 1,
    id: "stop3880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3866"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: 0,
    id: "stop3868"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cccccc",
    stopOpacity: 0,
    offset: 1,
    id: "stop3870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3767"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    offset: 0,
    id: "stop3769"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0,
    offset: 1,
    id: "stop3771"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3759"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a1a1a",
    offset: 0,
    id: "stop3761"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f30000",
    stopOpacity: 0,
    offset: 1,
    id: "stop3763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3765",
    y2: 535.37097,
    x2: 883.75842,
    y1: 542.3974,
    x1: 897.22186
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3773",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3785",
    y2: 535.37097,
    x2: 876.64569,
    y1: 552.05042,
    x1: 880.71014
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3789",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-22,316.2677)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3811",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-24,320.2677)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3813",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3843",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3845",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3847",
    y2: 535.37097,
    x2: 883.75842,
    y1: 542.3974,
    x1: 897.22186
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3849",
    y2: 535.37097,
    x2: 876.64569,
    y1: 552.05042,
    x1: 880.71014
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-22,316.2677)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3851",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-24,320.2677)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3767",
    id: "linearGradient3853",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,130.62129,-29.069768)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3866",
    id: "linearGradient3872",
    y2: 863.93677,
    x2: 242.62505,
    y1: 865.19409,
    x1: 263.89166
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,120.60901,-30.101958)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3876",
    id: "linearGradient3874",
    y2: 863.93677,
    x2: 232.43333,
    y1: 864.27179,
    x1: 252.14371
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,-0.13798685,-0.13798685,-0.99043406,120.60901,1463.2521)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3876",
    id: "linearGradient3886",
    y2: 863.93677,
    x2: 232.43333,
    y1: 864.27179,
    x1: 252.14371
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,-0.13798685,-0.13798685,-0.99043406,130.62129,1462.2199)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3866",
    id: "linearGradient3888",
    y2: 863.93677,
    x2: 242.62505,
    y1: 865.19409,
    x1: 263.89166
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,146.04655,-33.884618)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3960",
    y2: 863.93677,
    x2: 232.43333,
    y1: 865.07489,
    x1: 254.25746
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,156.30883,-32.602428)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3962",
    y2: 863.93677,
    x2: 242.62505,
    y1: 865.19409,
    x1: 263.89166
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3991",
    y2: 535.37097,
    x2: 876.64569,
    y1: 552.05042,
    x1: 880.71014
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3994",
    y2: 535.37097,
    x2: 883.75842,
    y1: 542.3974,
    x1: 897.22186
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient3997",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4000",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.89332217,0,0,0.89332217,92.369757,365.14619)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4008",
    y2: 533.5,
    x2: 874.86749,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.89332217,0,0,0.89332217,94.156401,361.5729)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4011",
    y2: 528.41949,
    x2: 876.13763,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4131",
    y2: 501.07629,
    x2: 835.98706,
    y1: 552.05042,
    x1: 880.71014
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(21.43754,297.90666)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4133",
    y2: 531.909,
    x2: 815.8241,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.89332217,0,0,0.89332217,92.369757,365.14619)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4135",
    y2: 533.5,
    x2: 812.13739,
    y1: 537.5,
    x1: 879.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.89332217,0,0,0.89332217,94.156401,361.5729)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4137",
    y2: 529.60681,
    x2: 805.29413,
    y1: 528.35504,
    x1: 887.89642
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,146.04655,-33.884618)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4139",
    y2: 867.67596,
    x2: 205.59436,
    y1: 873.13715,
    x1: 229.69746
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.99043406,0.13798685,-0.13798685,0.99043406,156.30883,-32.602428)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4141",
    y2: 872.64813,
    x2: 216.55965,
    y1: 873.05804,
    x1: 238.83344
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4149",
    y2: 19.592937,
    x2: 13.695145,
    y1: 19.872129,
    x1: 14.678357
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4153",
    y2: 22.120347,
    x2: 13.615251,
    y1: 22.266809,
    x1: 16.491694
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4155",
    y2: 19.594922,
    x2: 12.749702,
    y1: 19.799639,
    x1: 15.469636
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4185",
    y2: 17.003155,
    x2: 13.695145,
    y1: 16.723962,
    x1: 14.678357
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4187",
    y2: 17.109569,
    x2: 15.211872,
    y1: 17.111929,
    x1: 15.711045
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4189",
    y2: 17.001172,
    x2: 12.749702,
    y1: 16.796455,
    x1: 15.469636
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4191",
    y2: 12.678005,
    x2: 7.27572,
    y1: 12.486938,
    x1: 7.532872
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4193",
    y2: 13.610568,
    x2: 6.363285,
    y1: 12.224447,
    x1: 7.217497
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4195",
    y2: 18.923824,
    x2: 13.570121,
    y1: 18.969658,
    x1: 17.076677
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4197",
    y2: 18.726499,
    x2: 13.615251,
    y1: 18.580038,
    x1: 16.491694
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4199",
    y2: 25.952873,
    x2: 5.286707,
    y1: 25.448389,
    x1: 6.884073
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4201",
    y2: 27.72477,
    x2: 6.109362,
    y1: 27.50684,
    x1: 7.706729
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4203",
    y2: 19.486515,
    x2: 15.211872,
    y1: 19.484156,
    x1: 15.711045
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4205",
    y2: 14.75762,
    x2: 7.27572,
    y1: 14.948688,
    x1: 7.532872
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4207",
    y2: 13.825057,
    x2: 6.363285,
    y1: 15.211179,
    x1: 7.217497
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4209",
    y2: 21.923027,
    x2: 13.570121,
    y1: 21.877193,
    x1: 17.076677
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4211",
    y2: 31.194479,
    x2: 5.286707,
    y1: 31.698963,
    x1: 6.884073
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3759",
    id: "linearGradient4213",
    y2: 34.164553,
    x2: 6.109362,
    y1: 34.382484,
    x1: 7.706729
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0.996078,
    stroke: "#191919",
    strokeWidth: 14,
    strokeMiterlimit: 4,
    id: "path3855",
    d: "m367.688385,93.998283c-0.944427,0.005623 -2.955566,0.19088 -4.049622,0.586906l-2.191101,0.939056l5.419067,22.49823l-78.136444,0.176071c-1.525208,0.00312 -3.059814,-0.008751 -4.597351,-0.019524c-3.075134,-0.021477 -6.175842,-0.065453 -9.292664,-0.13694c-4.56546,-0.104744 -9.183228,-0.258507 -13.811829,-0.449974c-0.247833,-0.010277 -0.495422,-0.028618 -0.743408,-0.039131c-9.348236,-0.394516 -18.785614,-0.933846 -28.190887,-1.525955c-12.724991,-0.803032 -25.367081,-1.694946 -37.640121,-2.425903c-9.095108,-0.541702 -17.98735,-0.988876 -26.52803,-1.252083c-5.865448,-0.180756 -11.559052,-0.285797 -17.059326,-0.254318c-2.701843,0.01548 -5.363785,0.058418 -7.962326,0.136948c-2.598541,0.07856 -5.246277,0.22242 -7.923203,0.410843c-1.33847,0.094177 -2.67804,0.194221 -4.03006,0.313019c-4.049789,0.355843 -8.166656,0.827255 -12.266304,1.369453c-0.00631,0.00061 -0.013199,-0.00061 -0.019524,0c-2.73735,0.362198 -5.458084,0.767227 -8.177521,1.193375c-2.719444,0.42617 -5.429871,0.875107 -8.099274,1.349907c-2.662987,0.473648 -5.302788,0.97998 -7.884071,1.486839c-0.006256,0.001251 -0.013268,-0.001259 -0.019539,0c-1.293617,0.254089 -2.547798,0.503448 -3.814865,0.76297c-3.794662,0.777321 -7.470955,1.57515 -10.955536,2.36721c-0.006317,0.001259 -0.013206,-0.001266 -0.019539,0c-2.32663,0.528938 -4.56208,1.048714 -6.710251,1.565094c-4.296997,1.031944 -8.210678,2.024986 -11.601128,2.914986c-5.085659,1.33503 -9.003941,2.458557 -11.32724,3.130188c-1.548588,0.44809 -2.386738,0.704285 -2.386738,0.704285l-8.56879,2.347641c-0.56493,0.155701 -1.113171,0.433762 -1.64333,0.821686c-0.180122,0.131775 -0.352043,0.272888 -0.528214,0.430389c-0.688377,0.613281 -1.346607,1.421524 -1.975918,2.406326c-0.002869,0.004395 0.00288,0.015198 0,0.019531c-0.31324,0.491272 -0.640091,1.026978 -0.939041,1.604218c-0.002628,0.005005 0.002632,0.014526 0,0.019531c-0.298981,0.578262 -0.595448,1.198349 -0.88036,1.858536c-0.002319,0.005615 0.002319,0.013916 0,0.019531c-2.2957,5.32724 -4.144369,13.229004 -5.59514,22.674286c-0.000938,0.006271 0.00094,0.01326 0,0.019516c-0.022509,0.146591 -0.036369,0.302643 -0.058699,0.449966c-0.315901,2.085648 -0.62104,4.255936 -0.89991,6.475586c-0.019081,0.151917 -0.039791,0.297501 -0.058691,0.449966c-0.314009,2.531158 -0.59268,5.13504 -0.8608,7.805893c-0.000629,0.006256 0.00062,0.013214 0,0.019516c-0.13368,1.332474 -0.268641,2.688721 -0.39127,4.049683c-0.00057,0.006271 0.00058,0.013062 0,0.019531c-0.122591,1.361206 -0.240379,2.722794 -0.35214,4.108368c-0.000509,0.006256 0.000521,0.013062 0,0.019531c-0.223959,2.778107 -0.424561,5.600403 -0.606461,8.451492c-0.00042,0.006302 0.000401,0.013077 0,0.019516c-0.54628,8.566757 -0.91375,17.396774 -1.11512,26.019684c-0.000158,0.0065 0.000151,0.012955 0,0.019516c-0.134239,5.752914 -0.195709,11.402222 -0.195709,16.844513c0,0.605789 0.01725,1.228836 0.019569,1.838974c-0.002319,0.610153 -0.019569,1.2332 -0.019569,1.838989c0,5.442291 0.06146,11.091599 0.19565,16.84433c0.00016,0.006561 -0.000151,0.013031 0,0.019531c0.201349,8.622894 0.56884,17.452911 1.11512,26.019653c0.000401,0.00647 -0.00041,0.013214 0,0.019531c0.1819,2.851105 0.3825,5.67337 0.606461,8.451477c0.000519,0.00647 -0.000521,0.013245 0,0.019531c0.111759,1.38559 0.229559,2.747162 0.352139,4.108398c0.000582,0.006439 -0.000568,0.013214 0,0.019501c0.122631,1.360992 0.257582,2.717194 0.391281,4.049683c0.00061,0.006378 -0.000629,0.013214 0,0.019531c0.268101,2.670868 0.546789,5.27475 0.860779,7.805908c0.018902,0.152435 0.039612,0.298035 0.058701,0.449951c0.27886,2.219635 0.584011,4.389954 0.89991,6.475555c0.02232,0.147339 0.03619,0.303406 0.058691,0.449982c0.00094,0.006287 -0.00094,0.013458 0,0.019531c1.450779,9.445282 3.299459,17.347046 5.59516,22.674286c0.002312,0.005615 -0.002319,0.01413 0,0.019531c0.284901,0.660187 0.581371,1.280273 0.880341,1.858521c0.002628,0.005005 -0.002632,0.014465 0,0.019531c0.298958,0.57724 0.625801,1.112946 0.939049,1.604218c0.002892,0.004395 -0.00288,0.015137 0,0.019531c0.629311,0.984802 1.287521,1.79306 1.97591,2.406342c0.17617,0.157501 0.348091,0.298615 0.528221,0.430389c0.530159,0.387909 1.078388,0.665985 1.64333,0.821686l8.568779,2.347626c0,0 0.83815,0.256195 2.386749,0.704285c2.323303,0.671631 6.24157,1.795166 11.327232,3.130188c3.39045,0.890015 7.304131,1.883057 11.601128,2.915009c2.14817,0.516357 4.383621,1.036133 6.710251,1.565094c0.006393,0.001251 0.013222,-0.001282 0.019539,0c3.484581,0.792053 7.160873,1.589874 10.955521,2.367188c1.267082,0.259521 2.521263,0.508881 3.81488,0.763c0.006332,0.001251 0.01326,-0.001282 0.019539,0c2.581284,0.506836 5.221085,1.013184 7.884071,1.486816c2.669411,0.474823 5.379829,0.923737 8.099281,1.349915c2.719421,0.426147 5.440147,0.831177 8.177521,1.193359c0.006348,0.00061 0.013206,-0.00061 0.019531,0c4.09964,0.542206 8.216484,1.013611 12.266281,1.369476c1.35202,0.118774 2.691589,0.218811 4.03006,0.313019c2.676941,0.188416 5.324661,0.332275 7.923203,0.410828c2.598557,0.078552 5.260468,0.12146 7.962326,0.136932c5.500275,0.031494 11.193878,-0.073547 17.059311,-0.254303c8.54068,-0.263214 17.432953,-0.710388 26.528061,-1.252075c12.27301,-0.730988 24.91507,-1.622864 37.64006,-2.425903c9.405304,-0.592102 18.842712,-1.131439 28.190948,-1.52597c0.247955,-0.010498 0.495544,-0.028839 0.743408,-0.039124c4.628601,-0.191467 9.246368,-0.345245 13.811798,-0.449951c3.116852,-0.071503 6.217529,-0.115479 9.292664,-0.136963c1.537537,-0.010773 3.072174,-0.022858 4.597382,-0.019531l78.136414,0.176086l-5.419037,22.498199l2.191071,0.939056c1.094086,0.396027 3.105194,0.581299 4.049652,0.586914c0.531219,0.003143 1.098724,-0.046387 1.682465,-0.156494c0.194489,-0.036621 0.39035,-0.088318 0.586914,-0.136963c0.190674,-0.047333 0.396027,-0.098083 0.586914,-0.156494c0.393402,-0.12088 0.791016,-0.263916 1.173828,-0.43042c1.14035,-0.496765 2.212555,-1.209167 2.993195,-2.07373c0.006256,-0.006683 0.013611,-0.012909 0.019531,-0.019531c0.391144,-0.43689 0.69632,-0.908539 0.919495,-1.428162l7.610168,-19.602783l68.824219,0.156525c0.46756,0.23407 0.924072,0.466461 1.389008,0.684723c1.865082,0.87616 3.70047,1.625854 5.536438,2.269379c0.915436,0.320892 1.82663,0.610687 2.738861,0.880371c3.19278,0.943726 6.378021,1.597351 9.605652,2.034607c1.844452,0.249969 3.709839,0.434418 5.595184,0.567352c0.942596,0.066406 1.899353,0.112762 2.856262,0.156525c1.913818,0.087616 3.842957,0.13324 5.829895,0.156494c3.973755,0.046387 8.125549,0 12.520569,0c6.51709,0 12.722473,-0.332581 18.643982,-0.97818c2.368652,-0.25827 4.689697,-0.561859 6.9646,-0.919495c4.549805,-0.715271 8.907471,-1.639526 13.087952,-2.738922c1.045105,-0.274841 2.088257,-0.562622 3.110596,-0.860779c3.066956,-0.89447 6.017944,-1.894012 8.881836,-2.993256c0.954529,-0.366394 1.904358,-0.726532 2.83667,-1.115112c1.864563,-0.777222 3.682373,-1.600769 5.458191,-2.465027c0.887939,-0.432129 1.775146,-0.876862 2.640991,-1.330322c1.731873,-0.906982 3.422424,-1.865601 5.067017,-2.856323c0.822266,-0.495331 1.625244,-1.010071 2.425781,-1.52594c4.003113,-2.579346 7.739746,-5.399872 11.2099,-8.471069c2.772522,-2.453766 5.384949,-5.058289 7.825378,-7.805908c0.003174,-0.003754 -0.003113,-0.0159 0,-0.019531c0.607544,-0.684204 1.212585,-1.372009 1.799866,-2.07373c0.003113,-0.003754 -0.003113,-0.015717 0,-0.019531c0.587097,-0.701752 1.174255,-1.413452 1.741211,-2.132446c0.003113,-0.003754 -0.003174,-0.015594 0,-0.019531c1.706299,-2.164948 3.326233,-4.394073 4.851746,-6.710327c0.003113,-0.004395 -0.003174,-0.015015 0,-0.019531c0.506348,-0.769135 1.019714,-1.542816 1.506348,-2.328064c0.003174,-0.005005 -0.003113,-0.014893 0,-0.019531c1.465271,-2.365204 2.859009,-4.79071 4.147461,-7.297241c0.002563,-0.005005 -0.002502,-0.014465 0,-0.019531c0.427612,-0.832092 0.84375,-1.676575 1.252075,-2.523712c0.002563,-0.005005 -0.002502,-0.014313 0,-0.019531c0.408203,-0.847198 0.823853,-1.700897 1.212952,-2.562836c0.002563,-0.005615 -0.002502,-0.014221 0,-0.019531c0.780334,-1.72937 1.526306,-3.475555 2.230225,-5.262604c0.002502,-0.005615 -0.002502,-0.014038 0,-0.019531c0.350769,-0.890778 0.685364,-1.795135 1.017334,-2.699799c0.001831,-0.005615 -0.001892,-0.013885 0,-0.019531c0.331787,-0.904755 0.665039,-1.820526 0.978149,-2.738892c0.313049,-0.918488 0.625061,-1.846222 0.919495,-2.778046c0.001892,-0.005615 -0.001831,-0.013763 0,-0.019531c0.294373,-0.931915 0.584961,-1.872192 0.86084,-2.817169c0.001831,-0.006287 -0.001892,-0.01358 0,-0.019501c0.275696,-0.945068 0.544678,-1.898407 0.802063,-2.856323c0.001892,-0.006256 -0.001831,-0.01358 0,-0.019531c0.775146,-2.886108 1.482727,-5.825867 2.093323,-8.823212l0,-0.019501c0.202576,-0.995026 0.382629,-2.006073 0.567383,-3.012817l0,-0.019531c1.298828,-7.085724 2.167358,-14.437653 2.601929,-22.048233c0.000305,-0.00647 -0.000427,-0.013229 0,-0.019531c0.06134,-1.081741 0.111877,-2.175888 0.156494,-3.267136c0.000244,-0.006454 -0.000244,-0.013214 0,-0.019516c0.089233,-2.189224 0.154419,-4.38678 0.176025,-6.612518c0,-0.00647 -0.000061,-0.013229 0,-0.019531c0.010681,-1.116196 0.006287,-2.23996 0,-3.364944c0,-0.398041 -0.013733,-0.795959 -0.019409,-1.19339c0.006287,-0.39743 0.019409,-0.795349 0.019409,-1.19339c0.006287,-1.124985 0.010681,-2.248749 0,-3.364944c-0.000061,-0.006378 0,-0.013062 0,-0.019516c-0.021301,-2.225754 -0.086792,-4.423309 -0.176025,-6.612518c-0.000244,-0.006393 0.000244,-0.013077 0,-0.019531c-0.044434,-1.091232 -0.095154,-2.185394 -0.156494,-3.267136c-0.000427,-0.006378 0.000305,-0.013062 0,-0.019516c-0.43457,-7.61058 -1.303101,-14.96254 -2.601929,-22.048264l0,-0.019516c-0.184753,-1.006729 -0.364807,-2.017761 -0.567383,-3.012802l0,-0.019531c-0.610596,-2.997314 -1.318176,-5.937088 -2.093323,-8.823196c-0.001831,-0.006271 0.001892,-0.013336 0,-0.019531c-0.257385,-0.957901 -0.526367,-1.91124 -0.802063,-2.856293c-0.001892,-0.006271 0.001831,-0.013336 0,-0.019531c-0.275879,-0.944977 -0.566467,-1.885254 -0.86084,-2.817169c-0.001831,-0.005615 0.001892,-0.013947 0,-0.019531c-0.294434,-0.931824 -0.606445,-1.859573 -0.919495,-2.77803c-0.31311,-0.918365 -0.646362,-1.834137 -0.978149,-2.738907c-0.001892,-0.0056 0.001831,-0.013947 0,-0.019531c-0.33197,-0.904648 -0.666565,-1.809036 -1.017334,-2.699799c-0.002502,-0.0056 0.002502,-0.013931 0,-0.019516c-0.703918,-1.787064 -1.44989,-3.533203 -2.230225,-5.262604c-0.002502,-0.00502 0.002563,-0.013962 0,-0.019547c-0.389038,-0.861923 -0.804749,-1.715637 -1.212952,-2.562836c-0.002502,-0.005005 0.002563,-0.014587 0,-0.019531c-0.408325,-0.847107 -0.824463,-1.691605 -1.252075,-2.523697c-0.002502,-0.00502 0.002563,-0.014603 0,-0.019547c-1.288452,-2.5065 -2.68219,-4.932022 -4.147461,-7.297241c-0.003113,-0.004395 0.003174,-0.014572 0,-0.019531c-0.486633,-0.785248 -1,-1.558929 -1.506348,-2.328064c-0.003174,-0.004395 0.003113,-0.015137 0,-0.019516c-1.525513,-2.316284 -3.145386,-4.54538 -4.851746,-6.710342c-0.003174,-0.003738 0.003113,-0.015869 0,-0.019531c-0.566956,-0.718979 -1.154114,-1.43071 -1.741211,-2.132446c-0.003113,-0.003723 0.003113,-0.015839 0,-0.019501c-0.587219,-0.701752 -1.192322,-1.389572 -1.799866,-2.073761c-0.003113,-0.003738 0.003174,-0.015839 0,-0.019531c-2.44043,-2.74762 -5.052856,-5.352127 -7.825378,-7.805878c-3.470154,-3.071213 -7.206787,-5.891739 -11.2099,-8.4711c-0.800598,-0.515869 -1.603577,-1.030586 -2.425781,-1.525948c-1.644531,-0.990723 -3.335083,-1.949341 -5.067017,-2.8563c-0.865845,-0.453468 -1.753052,-0.898201 -2.640991,-1.33033c-1.775879,-0.864258 -3.593689,-1.68782 -5.458191,-2.465012c-0.932312,-0.388611 -1.882141,-0.748726 -2.83667,-1.115128c-2.863892,-1.099243 -5.81488,-2.098778 -8.881836,-2.99324c-1.022339,-0.298157 -2.065491,-0.58596 -3.110596,-0.860802c-4.180481,-1.099388 -8.538147,-2.023659 -13.087952,-2.738907c-2.274902,-0.357658 -4.595947,-0.661232 -6.9646,-0.919502c-5.921387,-0.646439 -12.12677,-0.978981 -18.64386,-0.978981c-4.395081,0 -8.546875,-0.046387 -12.520599,0c-1.986938,0.02327 -3.916077,0.068893 -5.829895,0.156502c-0.956879,0.043762 -1.913635,0.090103 -2.856262,0.156509c-1.885315,0.132942 -3.750702,0.317383 -5.595154,0.567352c-3.227631,0.437279 -6.412872,1.090897 -9.605652,2.034622c-0.912262,0.269676 -1.823425,0.559464 -2.738861,0.880356c-1.835968,0.643539 -3.671417,1.393234 -5.536438,2.269394c-0.464966,0.218246 -0.921417,0.450645 -1.389038,0.684738l-68.824219,0.156487l-7.610199,-19.602776c-0.223145,-0.519615 -0.52832,-0.991234 -0.919495,-1.428154c-0.006256,-0.006569 -0.013336,-0.012901 -0.019531,-0.019531c-0.780609,-0.864594 -1.852844,-1.576965 -2.993195,-2.073738c-0.382782,-0.166481 -0.780365,-0.30954 -1.173828,-0.430412c-0.190887,-0.058395 -0.396179,-0.109177 -0.586884,-0.156509c-0.196594,-0.04863 -0.392426,-0.100319 -0.586975,-0.13694c-0.583679,-0.110115 -1.151184,-0.159637 -1.682465,-0.156509l0.000031,-0.000237l0,0l0,0l0,-0.000008z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2853",
    d: "m372.688385,90.998283c-0.944427,0.005623 -2.955566,0.191635 -4.049622,0.586906l-2.191101,0.939056l5.419067,22.439537l-78.136444,0.176064c-48.807678,0.103561 -104.249313,-7.201714 -145.825943,-5.94735c-41.576645,1.254372 -95.234882,17.529045 -95.234882,17.529045l-8.56879,2.367203c-12.05196,3.315659 -16.100719,60.955414 -16.100719,104.41127c0,0.696793 0.01668,1.410522 0.019569,2.112869c-0.00289,0.702347 -0.019569,1.416077 -0.019569,2.112869c0,43.455887 4.048759,101.095596 16.100719,104.41127l8.56879,2.367218c0,0 53.658237,16.274658 95.234882,17.529022c41.57663,1.254364 97.018265,-6.050903 145.825943,-5.947357l78.136444,0.176086l-5.419067,22.439514l2.191101,0.939056c1.094055,0.395294 3.105164,0.581299 4.049622,0.586914c0.53125,0.003143 1.098755,-0.04657 1.682495,-0.156525c0.194519,-0.03656 0.39035,-0.088379 0.586914,-0.136932c0.190643,-0.04718 0.395996,-0.098206 0.586884,-0.156525c0.393433,-0.120605 0.791016,-0.264221 1.173828,-0.430389c1.14035,-0.495819 2.212585,-1.191193 2.993195,-2.054169c0.006287,-0.006714 0.013611,-0.013031 0.019531,-0.019531c0.391174,-0.436096 0.69635,-0.909515 0.919495,-1.428162l7.610199,-19.56366l68.824188,0.156525c14.962524,7.476379 28.49173,6.710327 46.07193,6.710327c83.418762,0 117.460999,-54.206238 117.067749,-126.068237c0,-0.488449 -0.011841,-0.980133 -0.019409,-1.46727c0.007568,-0.487152 0.019409,-0.978836 0.019409,-1.467285c0.39325,-71.861984 -33.648987,-126.068237 -117.067688,-126.068237c-17.580231,0 -31.109467,-0.766037 -46.07196,6.710342l-68.824219,0.156509l-7.610199,-19.563667c-0.223145,-0.518623 -0.52832,-0.99205 -0.919495,-1.428154c-0.006256,-0.006508 -0.013336,-0.012886 -0.019531,-0.019516c-0.780609,-0.862984 -1.852844,-1.55835 -2.993195,-2.054184c-0.382782,-0.166176 -0.780365,-0.309769 -1.173828,-0.430405c-0.190857,-0.058304 -0.396179,-0.109314 -0.586884,-0.156525c-0.196564,-0.048569 -0.392395,-0.100357 -0.586914,-0.13694c-0.58371,-0.109917 -1.151215,-0.15963 -1.682495,-0.156509l0,-0.000099l0,0.000023z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#262626",
    fillOpacity: 0.996078,
    id: "path3643",
    d: "m236.104858,320.337769c-20.887161,0 -40.884567,1.126892 -59.355499,3.169342c16.06424,30.496582 61.342285,18.947205 128.688385,19.739716c31.105499,0.366058 56.057343,1.176514 76.082245,1.486847c-29.523712,-14.608063 -83.592651,-24.395905 -145.415131,-24.395905z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#000000",
    fillOpacity: 0.996078,
    id: "path3658",
    d: "m236.104858,320.337769c-2.007355,0 -3.996033,0.018494 -5.98642,0.039154c0.512253,10.123657 4.0242,18.941711 9.136139,24.317627c2.9245,-0.047333 5.944275,-0.123047 9.03833,-0.21521c-5.362488,-5.128693 -9.135559,-13.915558 -9.840424,-24.141571c-0.783356,-0.003113 -1.561768,0 -2.347626,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#191919",
    strokeWidth: 5,
    strokeMiterlimit: 4,
    id: "path3707",
    d: "m604.641113,302.973755l-3.188843,0.371704c-13.487793,1.573029 -23.594177,16.26355 -24.591187,34.13858l-0.234802,4.46051l3.286621,-3.032349c9.947205,-9.190521 17.718872,-20.350861 23.41748,-33.023468l1.31073,-2.914978z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "none",
    stroke: "#292929",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    id: "path3715",
    d: "m475.961304,309.858948c0,0 49.88092,-14.14621 65.969482,-20.02179c16.802429,-6.136292 61.889282,-24.506622 61.889282,-24.506622c0,0 -5.472168,26.587616 -19.083435,36.25885c-48.344543,34.350494 -145.669922,33.714417 -145.669922,33.714417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4149)",
    id: "path3757",
    d: "m530.110352,296.924896l-2.778015,1.467285c0.619263,0.724213 1.124084,1.520416 1.486877,2.406342c3.003662,7.335266 -6.721069,18.302795 -16.824585,22.400391c-0.323486,0.131195 -1.134888,0.526245 -2.132446,1.036865l8.529724,-2.425903c10.834045,-5.2948 17.19751,-14.450165 14.398743,-21.285278c-0.573547,-1.400635 -1.487,-2.608093 -2.680237,-3.599701l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4203)",
    id: "path3787",
    d: "m535.484375,294.132111l-2.778015,1.467285c0.619202,0.724213 1.124084,1.520416 1.486877,2.406342c3.003662,7.335266 -6.721069,18.302795 -16.824585,22.400391c-0.323547,0.131195 -1.134949,0.526245 -2.132446,1.036865l8.529663,-2.425903c10.834106,-5.2948 17.197571,-14.450165 14.398682,-21.285248c-0.573486,-1.400696 -1.486938,-2.608124 -2.680115,-3.599731l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4155)",
    id: "path3752",
    d: "m539.357727,293.246735l-2.778015,1.467285c0.619202,0.724213 1.124023,1.520416 1.486816,2.406342c3.003662,7.335266 -6.721069,18.302765 -16.824524,22.400391c-0.323547,0.131195 -1.134949,0.526245 -2.132446,1.036865l8.529724,-2.425903c10.834045,-5.2948 17.19751,-14.450165 14.398682,-21.285278c-0.573547,-1.400635 -1.487,-2.608093 -2.680176,-3.599701l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4205)",
    id: "path3735",
    d: "m549.941772,290.571533l-3.873596,1.154236c0.601135,1.072327 1.035767,2.211365 1.271667,3.423645c1.95282,10.037811 -13.122986,21.462799 -26.938843,24.102417c-2.125366,0.406067 -18.08252,5.368927 -20.13208,5.511932l0,2.582397l25.942383,-7.605194c16.455688,-3.440918 28.139648,-14.053284 26.215088,-23.945923c-0.372925,-1.916718 -1.224609,-3.668335 -2.484558,-5.223511l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4207)",
    id: "path3783",
    d: "m549.941772,290.571533l-3.873596,1.154236c0.601135,1.072327 1.035767,2.211365 1.271667,3.423645c1.95282,10.037811 -13.122986,21.462799 -26.938843,24.102417c-2.125366,0.406067 -18.08252,5.368927 -20.13208,5.511932l0,2.582397l25.942383,-7.605194c16.455688,-3.440918 28.139648,-14.053284 26.215088,-23.945923c-0.372925,-1.916718 -1.224609,-3.668335 -2.484558,-5.223511l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4209)",
    id: "path3799",
    d: "m522.067871,299.816833l-2.481628,1.31076c0.553162,0.646973 1.00415,1.358246 1.328186,2.149658c2.683289,6.552795 -6.004028,16.350281 -15.029663,20.010742c-0.289063,0.117218 -1.013916,0.470154 -1.904968,0.92627l7.619751,-2.167084c9.678284,-4.730011 15.362915,-12.908691 12.862671,-19.014618c-0.512329,-1.251251 -1.328308,-2.329926 -2.394226,-3.215729l-0.000122,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4153)",
    id: "path3803",
    d: "m513.424011,302.053864l-2.481628,1.310791c0.553101,0.646912 1.004089,1.358185 1.328186,2.149628c2.683289,6.552765 -6.004028,16.350281 -15.029785,20.010742c-0.28894,0.117249 -1.013855,0.470154 -1.904907,0.92627l7.619751,-2.167114c9.678284,-4.72998 15.362915,-12.90863 12.862671,-19.014557c-0.51239,-1.251251 -1.328308,-2.329926 -2.394226,-3.215698l-0.000061,-0.000061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4211)",
    id: "rect3861",
    d: "m131.510132,314.382324c5.191727,-1.266693 9.694519,-0.925781 12.393936,3.622986l-1.560928,11.204041c-4.304077,3.864685 -8.60817,3.099426 -12.912247,0.097321l2.079224,-14.924347l0.000015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4213)",
    id: "path3864",
    d: "m144.203781,316.425293c5.102341,-0.757629 9.494904,-0.358612 11.79631,3.448273l-1.485657,10.663788c-4.059158,1.862335 -8.127777,3.261414 -12.289612,0.09259l1.978973,-14.204651l-0.000015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#191919",
    fillRule: "nonzero",
    strokeWidth: 5,
    id: "path4025",
    d: "m236.104858,318.781158c-20.94342,0 -41.000488,1.120239 -59.53157,3.169342l-2.288925,0.254303l1.075974,2.034637c4.176346,7.928406 10.368179,13.217773 18.194016,16.550873c7.825867,3.333069 17.261185,4.765747 28.230072,5.282166c21.937744,1.032837 50.054291,-1.647247 83.633759,-1.252075c31.088165,0.365845 56.035248,1.176147 76.082245,1.486847l0.704285,-2.973663c-29.955414,-14.821686 -84.112213,-24.552429 -146.099854,-24.552429zm0,3.130219c57.07547,0 107.520203,8.43811 137.78537,21.109192c-18.751068,-0.364624 -40.825073,-1.005432 -68.432922,-1.330353c-33.766632,-0.397339 -61.962555,2.286407 -83.516373,1.271637c-10.776932,-0.507385 -19.887222,-1.944092 -27.173645,-5.047424c-6.544083,-2.78714 -11.572479,-6.983032 -15.337753,-13.088074c17.721512,-1.867493 36.770111,-2.914978 56.675323,-2.914978z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#262626",
    fillOpacity: 0.996078,
    stroke: "#191919",
    strokeWidth: 5,
    strokeMiterlimit: 4,
    id: "rect2864",
    d: "m148.558182,165.170898l-48.673874,7.805908c-16.997169,2.72583 -30.642738,30.533554 -31.927559,65.636078c1.284821,35.102509 14.930389,62.910248 31.927559,65.636108l48.673874,7.805878c8.323685,0 15.024719,-6.70108 15.024719,-15.024872l0,-116.834198c0,-8.323822 -6.701035,-15.024902 -15.024734,-15.024902l0.000015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#262626",
    fillOpacity: 0.996078,
    stroke: "#191919",
    strokeWidth: 5,
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path3703",
    d: "m418.670715,143.748688c-1.858795,0 -3.689392,0.207947 -5.497345,0.606476c-0.0065,-0.006271 -0.013031,-0.013153 -0.019531,-0.019516l-39.96814,7.708069c-11.098236,4.134781 -20.032959,8.934799 -20.032959,20.033203l0,133.072006c0,11.098419 8.934723,15.898438 20.032959,20.033203l39.96814,7.708069c0.006592,-0.006348 0.013031,-0.013214 0.019531,-0.019531c1.807922,0.39856 3.638489,0.606506 5.497345,0.606506c28.41925,0 51.45871,-35.911133 51.530121,-94.864212c-0.071411,-58.953079 -23.11087,-94.864197 -51.530121,-94.864197l0,-0.000076z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#262626",
    fillOpacity: 0.996078,
    id: "path4157",
    d: "m236.104858,156.887863c-20.887161,0 -40.884567,-1.126862 -59.355499,-3.169312c16.06424,-30.496574 61.342285,-18.94722 128.688385,-19.739731c31.105499,-0.366058 56.057343,-1.176498 76.082245,-1.486847c-29.523712,14.608063 -83.592651,24.395889 -145.415131,24.395889z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#000000",
    fillOpacity: 0.996078,
    id: "path4159",
    d: "m236.104858,156.887863c-2.007355,0 -3.996033,-0.018448 -5.98642,-0.039124c0.512253,-10.123672 4.0242,-18.941711 9.136139,-24.317627c2.9245,0.047333 5.944275,0.123032 9.03833,0.215195c-5.362488,5.128693 -9.135559,13.915573 -9.840424,24.141556c-0.783356,0.003128 -1.561768,0 -2.347626,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#191919",
    strokeWidth: 5,
    strokeMiterlimit: 4,
    id: "path4161",
    d: "m604.641113,174.251907l-3.188843,-0.371704c-13.487793,-1.573044 -23.594177,-16.26355 -24.591187,-34.138596l-0.234802,-4.46051l3.286621,3.032364c9.947205,9.190506 17.718872,20.350845 23.41748,33.023468l1.31073,2.914978z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "none",
    stroke: "#292929",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    id: "path4163",
    d: "m475.961304,167.366699c0,0 49.88092,14.146194 65.969482,20.02179c16.802429,6.136307 61.889282,24.506622 61.889282,24.506622c0,0 -5.472168,-26.587585 -19.083435,-36.258881c-48.344543,-34.350464 -145.669922,-33.71434 -145.669922,-33.71434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4185)",
    id: "path4165",
    d: "m530.110352,180.300751l-2.778015,-1.46727c0.619263,-0.724197 1.124084,-1.520432 1.486877,-2.406342c3.003662,-7.335297 -6.721069,-18.30278 -16.824585,-22.400375c-0.323486,-0.131226 -1.134888,-0.526276 -2.132446,-1.03688l8.529724,2.425888c10.834045,5.2948 17.19751,14.450165 14.398743,21.285278c-0.573547,1.400665 -1.487,2.608109 -2.680237,3.599701l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4187)",
    id: "path4167",
    d: "m535.484375,183.093582l-2.778015,-1.467285c0.619202,-0.724197 1.124084,-1.520416 1.486877,-2.406311c3.003662,-7.335312 -6.721069,-18.302811 -16.824585,-22.400406c-0.323547,-0.13121 -1.134949,-0.526276 -2.132446,-1.03688l8.529663,2.425903c10.834106,5.2948 17.197571,14.45018 14.398682,21.285263c-0.573486,1.400665 -1.486938,2.608124 -2.680115,3.599716l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4189)",
    id: "path4169",
    d: "m539.357727,183.978912l-2.778015,-1.46727c0.619202,-0.724197 1.124023,-1.520432 1.486816,-2.406326c3.003662,-7.335312 -6.721069,-18.302811 -16.824524,-22.400406c-0.323547,-0.13121 -1.134949,-0.526276 -2.132446,-1.036865l8.529724,2.425888c10.834045,5.2948 17.19751,14.450165 14.398682,21.285263c-0.573547,1.400681 -1.487,2.608124 -2.680176,3.599716l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4191)",
    id: "path4171",
    d: "m549.941772,186.654175l-3.873596,-1.154266c0.601135,-1.072281 1.035767,-2.211349 1.271667,-3.42363c1.95282,-10.037811 -13.122986,-21.462799 -26.938843,-24.102432c-2.125366,-0.406067 -18.08252,-5.368896 -20.13208,-5.511917l0,-2.582397l25.942383,7.605209c16.455688,3.440887 28.139648,14.053299 26.215088,23.945938c-0.372925,1.916702 -1.224609,3.668289 -2.484558,5.223495l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4193)",
    id: "path4173",
    d: "m549.941772,186.654175l-3.873596,-1.154266c0.601135,-1.072281 1.035767,-2.211349 1.271667,-3.42363c1.95282,-10.037811 -13.122986,-21.462799 -26.938843,-24.102432c-2.125366,-0.406067 -18.08252,-5.368896 -20.13208,-5.511917l0,-2.582397l25.942383,7.605209c16.455688,3.440887 28.139648,14.053299 26.215088,23.945938c-0.372925,1.916702 -1.224609,3.668289 -2.484558,5.223495l-0.000061,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4195)",
    id: "path4175",
    d: "m522.067871,177.408813l-2.481628,-1.31076c0.553162,-0.646942 1.00415,-1.358231 1.328186,-2.149643c2.683289,-6.552795 -6.004028,-16.350281 -15.029663,-20.010757c-0.289063,-0.117233 -1.013916,-0.470139 -1.904968,-0.926254l7.619751,2.167099c9.678284,4.729965 15.362915,12.908646 12.862671,19.014618c-0.512329,1.251221 -1.328308,2.329895 -2.394226,3.215698l-0.000122,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4197)",
    id: "path4177",
    d: "m513.424011,175.171783l-2.481628,-1.31076c0.553101,-0.646927 1.004089,-1.358231 1.328186,-2.149643c2.683289,-6.552795 -6.004028,-16.350281 -15.029785,-20.010757c-0.28894,-0.117218 -1.013855,-0.470123 -1.904907,-0.926254l7.619751,2.167099c9.678284,4.72998 15.362915,12.908661 12.862671,19.014587c-0.51239,1.251221 -1.328308,2.329895 -2.394226,3.215698l-0.000061,0.000031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4199)",
    id: "path4179",
    d: "m131.510132,162.843323c5.191727,1.266708 9.694519,0.925797 12.393936,-3.622986l-1.560928,-11.20401c-4.304077,-3.864716 -8.60817,-3.099426 -12.912247,-0.097321l2.079224,14.924316l0.000015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient4201)",
    id: "path4181",
    d: "m144.203781,160.800415c5.102341,0.757629 9.494904,0.358597 11.79631,-3.448303l-1.485657,-10.663757c-4.059158,-1.862335 -8.127777,-3.261429 -12.289612,-0.092621l1.978973,14.204681l-0.000015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#191919",
    fillRule: "nonzero",
    strokeWidth: 5,
    id: "path4183",
    d: "m236.104858,158.444473c-20.94342,0 -41.000488,-1.120209 -59.53157,-3.169312l-2.288925,-0.254318l1.075974,-2.034637c4.176346,-7.928391 10.368179,-13.217773 18.194016,-16.550858c7.825867,-3.333084 17.261185,-4.765762 28.230072,-5.282181c21.937744,-1.032822 50.054291,1.647247 83.633759,1.252075c31.088165,-0.365829 56.035248,-1.176147 76.082245,-1.486847l0.704285,2.973679c-29.955414,14.821655 -84.112213,24.552399 -146.099854,24.552399zm0,-3.130173c57.07547,0 107.520203,-8.438141 137.78537,-21.109192c-18.751068,0.364594 -40.825073,1.005417 -68.432922,1.330322c-33.766632,0.397339 -61.962555,-2.286392 -83.516373,-1.271637c-10.776932,0.507385 -19.887222,1.944092 -27.173645,5.047424c-6.544083,2.78717 -11.572479,6.983032 -15.337753,13.088089c17.721512,1.867493 36.770111,2.914993 56.675323,2.914993z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.58b7ed171f6f1e3bc5a58688c483579d.svg";
export { ForwardRef as ReactComponent };